export default function() {
	'ngInject';

    return function(messages, allowedMessageTypes) {
        return messages.filter(function(message) {
            return allowedMessageTypes[message.messageType];
        });
    };
};
